
import ResultCardComponent from '@/components/ResultCard/ResultCardComponent';
export default ResultCardComponent;
